// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3t95o","selects":"Documents_selects__1di6O"};